<template>
    <div>
        <h2 class="ssv-title__secondary">Kontakty pro vyřízení objednávky</h2>
        <ssv-order-contact-information-form v-bind="$props" ref="contactInformationForm"/>
    </div>
</template>

<script>
    import SsvOrderContactInformationForm from './ContactInformationForm';

    export default {
        name: 'SsvOrderContactInformationContainer',
        components: {
            SsvOrderContactInformationForm,
        },
        props: {
            required: {
                type: Boolean,
                default: false,
            },
            extended: {
                type: Boolean,
                default: false,
            },
            mktCommunication: {
                type:    Boolean,
                default: false,
            },
            sameParticipant:  {
                type:    Boolean,
                default: true,
            },
            hideDescriptions: {
                type: Boolean,
                default: false,
            },
            labels: {
                type: Object,
                required: false,
                default: () => ({
                    phone: 'Kdybychom potřebovali upřesnit údaje nebo došlo ke změně u pořádaného termínu.',
                    email: 'Tato adresa slouží k vyřízení objednávky, zaslání instrukcí ke školení, účetních dokladů atd.',
                })
            }
        },
        methods: {
            validate() {
                this.$refs.contactInformationForm.validate();
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/ssv-order/contact-information/ContactInformationContainer.vue